import loadable from '@loadable/component';

export const OrgDashboardCreateEventPageLoadable = loadable(
  () => import('./OrgDashboardCreateEventPage'),
  {
    resolveComponent: (module) => module.OrgDashboardCreateEventPage,
    ssr: false,
  },
);
